// extracted by mini-css-extract-plugin
export var callToAction = "HeaderWithImage-module--callToAction--14241";
export var content = "HeaderWithImage-module--content--4beba";
export var heroImage = "HeaderWithImage-module--heroImage--046b2";
export var heroSection = "HeaderWithImage-module--heroSection--dee9d";
export var highlight = "HeaderWithImage-module--highlight--d129e";
export var highlightIcon = "HeaderWithImage-module--highlightIcon--44545";
export var highlights = "HeaderWithImage-module--highlights--47b60";
export var imageContainer = "HeaderWithImage-module--imageContainer--36b0d";
export var subtitle = "HeaderWithImage-module--subtitle--07cd5";
export var title = "HeaderWithImage-module--title--482f2";